var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('validation-observer',[_c('global-events')],1),_c('v-row',[_c('v-col',[_vm._v(" "+_vm._s(_vm.mcTradeError ? 'This Profile is not found' : '')+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }